import React, { useEffect, useState } from "react";
import { countries } from "../../src/utils/Constants";
import PrivacyAndTermsModal from "../Modal/PrivacyAndTermsModal";
import Loading from "../components/Loading";
import { axiosInstance } from "../components/axiosInstance";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import contactimg from "../assests/image/img/contact-img.webp";
const ContactUsForm = () => {
  const [showPrivacyPopup, setShowPrivacyPopup] = useState(false);
  const openPrivacy = () => setShowPrivacyPopup(true);
  const [captcha, setCaptcha] = useState("");
  const [err, setErr] = useState({});
  const [loading, setLoading] = useState(false);

  const state = useLocation();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone_number: "",
    company_name: "",
    jobtitle: "",
    country: "",
    website: "",
    query_for: "",
    message: "",
    accept_terms: true,
    Captcha: "",
  });

  const validation = (formData) => {
    let err = "";
    if (formData?.name.trim() === "") {
      err = { ...err, Name: "This Field is Required" };
    }
    if (formData?.email.trim() === "") {
      err = { ...err, email: "This Field is Required" };
    }
    if (
      formData?.phone_number.trim().length < 10 ||
      formData?.phone_number.trim().length > 10
    ) {
      err = { ...err, Mobile: "Invalid Mobile no" };
    }
    // if (formData?.company_name.trim() === "") {
    //   err = { ...err, Company: "This Field is Required" };
    // }
    // if (formData?.jobtitle.trim() === "") {
    //   err = { ...err, jobtitle: "This Field is Required" };
    // }
    if (formData?.country.trim() === "") {
      err = { ...err, country: "This Field is Required" };
    }
    if (formData?.query_for?.trim() === "") {
      err = { ...err, query_for: "This Field is Required" };
    }
    // if (formData?.message?.trim() === "") {
    //   err = { ...err, message: "This Field is Required" };
    // }
    if (formData?.Captcha?.trim() === "") {
      err = { ...err, Captcha: "Please enter captcha" };
    } else if (formData?.Captcha !== captcha) {
      err = { ...err, Captcha: "Invalid Captcha" };
    }

    return err;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const generateCaptcha = () => {
    const chars =
      "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789@#$%&*!";
    let captcha = "";
    for (let i = 0; i < 6; i++) {
      captcha += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptcha(captcha);
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const handleSubmit = () => {
    let generatedError = validation(formData);
    if (generatedError == "") {
      setLoading(true);
      axiosInstance
        .post("/Mail/SendEmailAsync", { ...formData })
        .then((res) => {
          if (res.data.success) {
            toast.success(res.data.message);
            setLoading(false);
            setFormData({
              name: "",
              email: "",
              phone_number: "",
              company_name: "",
              jobtitle: "",
              country: "",
              query_for: "",
              message: "",
              accept_terms: true,
              Captcha: "",
            });
            setErr({});
          } else {
            toast.error(res.data.message);
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          toast.error(
            err?.response?.data?.message
              ? err?.response?.data?.message
              : "Error Occured"
          );
        });
    } else {
      setErr(generatedError);
      //  toast?.error("something went wrong")
      setLoading(false);
    }
  };
  return (
    <>
      {showPrivacyPopup && (
        <PrivacyAndTermsModal setShowPrivacyPopup={setShowPrivacyPopup} />
      )}
      <div className="contact-section pt-100 pb-70">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-5">
              <div className="contact-img">
                <img src={contactimg} alt="Images" loading="lazy" />
              </div>
            </div>

            <div className="col-lg-7">
              <div className="contact-wrap">
                <div className="contact-form">
                  <div className="section-title">
                    <span className="sp-before sp-after">contact</span>
                    {state?.pathname == "/contact-us" ? (
                      <h2>Contact With Us</h2>
                    ) : (
                      <h2>Get in Touch</h2>
                    )}
                  </div>

                  <div id="msgSubmit" className="h3 text-center hidden"></div>

                  <input type="hidden" name="frm_type" value="contactUs" />
                  <input type="hidden" name="frm_val" value="" />

                  <div className="row">
                    {/* Name */}
                    <div className="col-lg-6 col-sm-6">
                      <div className="form-group">
                        <i className="bx bx-user"></i>
                        <input
                          type="text"
                          name="name"
                          id="name"
                          className="form-control"
                          required
                          onChange={handleChange}
                          value={formData.name}
                          placeholder="Your Name*"
                        />
                        {err?.Name && formData?.name?.trim() === "" ? (
                          <div className="help-block with-errors">
                            {err?.Name}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    {/* Email */}
                    <div className="col-lg-6 col-sm-6">
                      <div className="form-group">
                        <i className="bx bx-user"></i>
                        <input
                          type="email"
                          name="email"
                          id="email"
                          className="form-control"
                          required
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="E-mail*"
                        />
                        {err?.email && formData?.email?.trim() === "" ? (
                          <div className="help-block with-errors">
                            {err?.email}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    {/* Phone */}
                    <div className="col-lg-6 col-sm-6">
                      <div className="form-group">
                        <i className="bx bx-phone"></i>
                        <input
                          type="text"
                          name="phone_number"
                          id="phone_number"
                          className="form-control"
                          required
                          value={formData.phone_number}
                          onChange={handleChange}
                          placeholder="Your Phone*"
                        />
                        {err?.Mobile &&
                        (formData?.phone_number?.trim()?.length < 10 ||
                          formData?.phone_number?.trim()?.length > 10) ? (
                          <div className="help-block with-errors">
                            {err?.Mobile}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    {/* Website */}
                    <div className="col-lg-6 col-sm-6">
                      <div className="form-group">
                        <i className="bx bx-link"></i>
                        <input
                          type="text"
                          name="website"
                          id="website"
                          className="form-control"
                          value={formData.website}
                          onChange={handleChange}
                          placeholder="Your Website (Optional)"
                        />
                      </div>
                    </div>

                    {/* Country */}
                    <div className="col-lg-6 col-sm-6">
                      <div className="form-group">
                        <i className="bx bx-flag"></i>
                        <select
                          id="country"
                          name="country"
                          required
                          value={formData.country}
                          className="form-control"
                          onChange={handleChange}
                        >
                          <option disabled value="">
                            -- Pls select your country --
                          </option>
                          {countries.map((country, index) => (
                            <option key={index} value={country.value}>
                              {country.label}
                            </option>
                          ))}
                        </select>
                        {err?.country && formData?.country?.trim() === "" ? (
                          <div className="help-block with-errors">
                            {err?.country}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    {/* Query For */}
                    <div className="col-lg-6 col-sm-6">
                      <div className="form-group">
                        <i className="bx bx-file"></i>
                        <select
                          id="query_for"
                          name="query_for"
                          required
                          value={formData.query_for}
                          className="form-control"
                          onChange={handleChange}
                        >
                          <option disabled value="">
                            -- select an option --
                          </option>
                          <option value="HR">HR</option>
                          <option value="SALES">SALES</option>
                          <option value="CUSTOMER SUPPORT">
                            CUSTOMER SUPPORT
                          </option>
                          <option value="MARKETING">MARKETING</option>
                        </select>
                        {err?.query_for &&
                        formData?.query_for?.trim() === "" ? (
                          <div className="help-block with-errors">
                            {err?.query_for}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    {/* Message */}
                    <div className="col-lg-12 col-md-12">
                      <div className="form-group">
                        <i className="bx bx-envelope"></i>
                        <textarea
                          name="message"
                          className="form-control"
                          id="message"
                          cols="30"
                          rows="5"
                          value={formData.message}
                          placeholder="Additional Details (optional)"
                          onChange={handleChange}
                        ></textarea>
                      </div>
                    </div>
                    {/* Captcha */}
                    <div className="form-group row align-items-center">
                      <div className="col-lg-12 col-sm-12 mb-2 d-flex">
                        <input
                          type="text"
                          name="Captcha"
                          className="form-control"
                          placeholder="Enter captcha"
                          value={formData.Captcha}
                          onChange={handleChange}
                        />

                        <div className="col-lg-6 col-sm-6 d-flex align-items-center gap-2">
                          <span
                            style={{
                              backgroundColor: "#f1f1f1",
                              color: "black",
                              padding: "8px 15px",
                              fontWeight: "bold",
                              letterSpacing: "2px",
                              borderRadius: "4px",
                              // display: "inline-block",
                              marginBottom: "5px",
                            }}
                          >
                            {captcha}
                          </span>
                          <button
                            type="button"
                            className="btn btn-sm btn-secondary"
                            onClick={generateCaptcha}
                          >
                            Refresh
                          </button>
                        </div>
                      </div>
                      {err?.Captcha && (
                        <div className="help-block with-errors">
                          {err?.Captcha}
                        </div>
                      )}
                    </div>

                    {/* Terms & Conditions */}
                    <div className="custom-control custom-checkbox d-flex align-items-center mb-20">
                      <input
                        type="checkbox"
                        required
                        className="custom-control-input mr-2"
                        name="accept_terms"
                        id="terms"
                        checked={formData.accept_terms}
                        // defaultChecked
                      />
                      <label className="custom-control-label" htmlFor="terms">
                        I accept the{" "}
                        <a
                          href="#terms-and-privacy-popup"
                          className="open-terms-and-privacy"
                          onClick={openPrivacy}
                        >
                          privacy and terms
                        </a>
                        .
                      </label>
                    </div>

                    {/* Submit Button */}
                    <div className="col-lg-12 col-md-12 mt-2">
                      {loading ? (
                        <Loading />
                      ) : (
                        <button
                          onClick={handleSubmit}
                          className="default-btn border-radius disabled"
                          id="aboutContactBtn"
                          style={{ pointerEvents: "all", cursor: "pointer" }}
                        >
                          Send Message
                          <i className="bx bx-chevrons-right"></i>
                        </button>
                      )}
                      <div className="clearfix"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-12 youtube-player">
            <iframe
              width="100%"
              height="500"
              src="https://www.youtube.com/embed/IDIVtkLIHvM"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen=""
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUsForm;
